import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const RecordingRulesModal = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./recording_rules_modal.js')).RecordingRulesModal })
  )
)
